import PageCommon from "./PageCommon.js";
import Pqp from "../3x1010/Pqp.js";
import Globals from "../Globals.js";
import { ModalConfirm, ModalAlert } from "../su/Modals.js";


export default class PageDefault extends PageCommon {
	constructor() {
		super();
	}
	init( $data ) {
		super.init($data );
		this.showPreloader(false);
		Pqp.trace("PageDefault - Hello world");
		let menuOpen = document.querySelector(".js-open-menu");
		let menuClose = document.querySelector(".js-close-menu");
		let menu = document.querySelector(".js-menu");
		let editPwd = document.querySelector(".js-edit-pwd");
		let editPwdPanel = document.querySelector(".js-change-pwd-panel");
		let backBtn = document.querySelector(".js-back-menu");
		let backBtnPhone = document.querySelector(".js-back-menu-phone");
		let btnModPhone = document.querySelector(".js-mod-btn-phone");
		let editPhonePanel = document.querySelector(".js-phone-panel");
		editPwd.addEventListener("click", this.openPanel.bind(this, editPwdPanel));
		btnModPhone.addEventListener("click", this.openPanel.bind(this, editPhonePanel));
		menuClose.addEventListener("click", this.closePanel.bind(this, menu));
		backBtn.addEventListener("click", this.closePanel.bind(this, editPwdPanel));
		backBtnPhone.addEventListener("click", this.closePanel.bind(this, editPhonePanel));
		menuOpen.addEventListener("click", this.openPanel.bind(this, menu));

		let phoneInput = document.querySelector(".js-phone-input");
		phoneInput.addEventListener("keyup", this.onCheckPhoneData.bind(this));

		if ($.trim($(".js-phone-input").val()) === '') {
			PageCommon.disable($(".js-phone-submit"), true);
		} else {
			PageCommon.disable($(".js-phone-submit"), false);
		}


		let phoneSubmit = document.querySelector(".js-phone-submit");
		phoneSubmit.addEventListener("click", this.onDoPhoneSubmit.bind(this));

		let smsNotification = document.querySelector(".js-sms-notification");
		smsNotification.addEventListener("change", this.onSmsNotificationChange.bind(this));


		let oldPasswordInput = document.querySelector(".js-oldpassword-input");
		oldPasswordInput.addEventListener("keyup", this.onCheckUpdatePasswordData.bind(this));

		let newPasswordInput = document.querySelector(".js-newpassword-input");
		newPasswordInput.addEventListener("keyup", this.onCheckUpdatePasswordData.bind(this));

		let repeatPasswordInput = document.querySelector(".js-repeatpassword-input");
		repeatPasswordInput.addEventListener("keyup", this.onCheckUpdatePasswordData.bind(this));


		PageCommon.disable($(".js-password-submit"), true);

		let passwordSubmit = document.querySelector(".js-password-submit");
		passwordSubmit.addEventListener("click", this.onDoPasswordSubmit.bind(this));

		// dispaccio un evento globale
		try {
			this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);
		} catch (error) {
			console.log(error);
        }
	}

	get isHomepage() {
		return true;
	}

	openPanel(panel) {
		panel.classList.add("active")
	}
	closePanel(panel) {
		panel.classList.remove("active")
	}

	onCheckPhoneData() {
		var mailformat = /^(?:(?:\+|00)39|0039|39)?([3]{1}[\d]{8,9})$/;

		let Phone = $.trim($(".js-phone-input").val());
		if (Phone != "" && Phone.match(mailformat)) {
			PageCommon.disable($(".js-phone-submit"), false);
			return true;
		} else {
			PageCommon.disable($(".js-phone-submit"), true);
			return false;
		}
	}

	onCheckUpdatePasswordData() {
		let enable = true;

		let OldPassword = $.trim($(".js-oldpassword-input").val());
		let NewPassword = $.trim($(".js-newpassword-input").val());
		let RepeatPassword = $.trim($(".js-repeatpassword-input").val());

		let viewPanel = false;

		if (NewPassword.length < 8 || RepeatPassword.length < 8) {
			enable = false;
			viewPanel = true;
		} else if (!this.validatePassword(NewPassword) || !this.validatePassword(RepeatPassword)) {
			enable = false;
			viewPanel = true;
		} else if (NewPassword != RepeatPassword) {
			enable = false;
			viewPanel = true;
		} else if (OldPassword.length < 8) {
			enable = false;
		}

		let alertPanel = $(".js-pwdalert");
		if (viewPanel) {
			if (NewPassword !== "" || RepeatPassword !== "") {
				if (alertPanel !== null) {
					alertPanel.show();
				}
			} else {
				if (alertPanel !== null) {
					alertPanel.hide();
				}
			}
		} else {
			if (alertPanel !== null) {
				alertPanel.hide();
			}
		}

		if (enable) {
			PageCommon.disable($(".js-password-submit"), false);
			return true;
		} else {
			PageCommon.disable($(".js-password-submit"), true);
			return false;
		}
	}

	onDoPhoneSubmit(e) {
		if (this.onCheckPhoneData()) {
			this.showPreloader(true);
			let rq = {
				MobilePhone: $.trim($(".js-phone-input").val()),
			}
			thatServiceManeger.standardCall("/api/app/updatemobilephone", rq, this.onDoPhoneSubmitHandler.bind(this));
		}
	}

	onDoPhoneSubmitHandler(rs) {
		//console.log("onDoPhoneSubmitHandler",rs);
		this.showPreloader(false);

		let showError = false;
		let errorMessage = "Impossibile salvare il numero di telefono.Riprova tra qualche istante."
		let successMessage = "Numero di telefono aggiornato con successo";
		if (rs.StatusCode !== 200) {
			showError = true;
		} else {
			showError = !rs.Success;
		}
		if (showError) {
			toastr.error(errorMessage);
			return;
		} else {
			toastr.success(successMessage);
			let phoneData = document.querySelector(".js-phone-data");
			phoneData.textContent = $.trim($(".js-phone-input").val());
			let editPhonePanel = document.querySelector(".js-phone-panel");
			this.closePanel(editPhonePanel);
			return;
		}
	}

	onSmsNotificationChange(event) {

		const isChecked = event.target.checked;
		let rq = {
			DeliverySmsNotification: isChecked
		}
		thatServiceManeger.standardCall("/api/app/UpdateDeliverySmsNotification", rq, this.onSmsNotificationChangeHandler.bind(this));
	}

	onSmsNotificationChangeHandler(rs) {
		//console.log("onSmsNotificationChangeHandler", rs);
		this.showPreloader(false);

		let smsNotification = document.querySelector(".js-sms-notification").checked;
		let showError = false;
		let errorMessage = "Impossibile aggiornare le preferenze per le notifiche SMS"
		let successMessage = "";
		if (smsNotification) {
			successMessage = "Riceverai SMS di notifica sugli aggiornamenti importanti";
		} else {
			successMessage = "Non riceverai più SMS di notifica"; 
		}
		if (rs.StatusCode !== 200) {
			showError = true;
		} else {
			showError = !rs.Success;
		}
		if (showError) {
			toastr.error(errorMessage);
			return;
		} else {
			toastr.success(successMessage);
			return;
		}
	}

	onDoPasswordSubmit(e) {
		if (this.onCheckUpdatePasswordData()) {
			this.showPreloader(true);
			let rq = {
				old_password: $.trim($(".js-oldpassword-input").val()),
				new_password: $.trim($(".js-newpassword-input").val()),
			}
			thatServiceManeger.standardCall("/api/auth/passwordchange", rq, this.onDoPasswordSubmitHandler.bind(this));
		}
	}

	onDoPasswordSubmitHandler(rs) {
		console.log("onDoPhoneSubmitHandler",rs);
		this.showPreloader(false);

		let showError = false;
		let errorMessage = "Si è verificato un errore durante l'aggiornamento della password."
		let successMessage = "Password modificata con successo";
		if (rs.StatusCode !== 200) {
			showError = true;
			if (rs.hasOwnProperty("Errors") && rs.Errors !== null && rs.Errors.length > 0) {
				errorMessage = rs.Errors[0].Message;
			}
		} else {
			showError = !rs.Success;
		}
		if (showError) {
			toastr.error(errorMessage);
			return;
		} else {
			toastr.success(successMessage);
			let editPwdPanel = document.querySelector(".js-change-pwd-panel");
			this.closePanel(editPwdPanel);
			return;
		}
	}

	validatePassword(value) {
		return this.containsUppercase(value) &&
			   this.containsLowercase(value) &&
			   this.containsNumber(value) &&
			   this.containsSpecial(value)
	}

	containsUppercase (value) {
		return /[A-Z]/.test(value)
	}
	containsLowercase (value) {
		return /[a-z]/.test(value)
	}
	containsNumber(value) {
		return /[0-9]/.test(value)
	}
	containsSpecial(value) {
		return /[@!£$%&:=<>|]/.test(value)
	}

}

